// src/components/Footer.js
import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="py-10 text-blue-500 bg-white">
      <div className="grid max-w-6xl grid-cols-1 gap-8 px-4 mx-auto md:grid-cols-3">
        {/* About Section */}
        <div className="mb-6">
          <h3 className="mb-3 text-lg font-bold">About Dhikroo Academy</h3>
          <p className="text-gray-400">
            Dhikroo is dedicated to providing a high-quality
            education that prepares students to excel in science and technology.
            Our mission is to foster innovation and curiosity in the minds of
            future leaders.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="mb-6">
          <h3 className="mb-3 text-lg font-bold">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="/about"
                className="text-gray-400 transition hover:text-white"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="/programs"
                className="text-gray-400 transition hover:text-white"
              >
                Our Programs
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="text-gray-400 transition hover:text-white"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="/blog"
                className="text-gray-400 transition hover:text-white"
              >
                Latest News
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Information Section */}
        <div>
          <h3 className="mb-3 text-lg font-bold">Get In Touch</h3>
          <p className="mb-2 text-center text-gray-400">
            <strong>Email:</strong> info@dhikrooacademy.com.ng
          </p>
          <p className="mb-2 text-gray-400">
            <strong>Phone:</strong>
            <a
              href="tel:+2348033692734"
              className="text-blue-500 hover:underline"
            >
              +234 9978 657 543
            </a>
          </p>

          <p className="text-gray-400">
            <strong>Address:</strong> Ilorin, Kwara State 
          </p>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="py-6 mt-8 border-t border-gray-700">
        <div className="flex justify-center space-x-6">
          <a
            href="https://www.facebook.com/profile.php?id=100083088863034"
            className="text-gray-400 transition hover:text-white"
            aria-label="Facebook"
          >
            <FaFacebookF size={20} />
          </a>
          <a
            href="https://twitter.com"
            className="text-gray-400 transition hover:text-white"
            aria-label="Twitter"
          >
            <FaTwitter size={20} />
          </a>
          <a
            href="https://instagram.com"
            className="text-gray-400 transition hover:text-white"
            aria-label="Instagram"
          >
            <FaInstagram size={20} />
          </a>
          <a
            href="https://linkedin.com"
            className="text-gray-400 transition hover:text-white"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn size={20} />
          </a>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="py-4 text-center bg-blue-800">
        <p className="text-gray-500">
          &copy; {new Date().getFullYear()} Dhikroo Academy. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
